import { Observable } from "rxjs";

export class BaseLink {
    public title: string;
    public link: string;
    public label: string;
    public showLabel: boolean;

    constructor(title: string, link: string, observableFunction: Observable<any> = null, label: string = "$s", showLabel: boolean = false) {
        this.title = title;
        this.link = link;
        this.label = label;
        this.showLabel = showLabel;

        if (observableFunction !== null) {
            observableFunction.subscribe(
                (data) => {
                    this.label = this.label.replace("$s", data.length);
                    this.showLabel = true;
                },
            );
        }
    }

    public setLabel(value: string, pattern: string = "$s"): void {
        this.label = pattern.replace("$s", value);
        this.showLabel = true;
    }
}
